import React, { useState } from 'react';
import { Dialog } from '@material-ui/core';
import { Wordify } from "../utils/utils";
import { makeStyles } from "@material-ui/core/styles";
import api from "../api";
import {toast} from "react-toastify";
import BeatLoader from "react-spinners/BeatLoader";

const useStyles = makeStyles((theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            borderRadius: '20px',
            boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.1)',
            backgroundColor: 'rgba(255, 255, 255, 1)',
            padding: '0',
            maxWidth: '400px',
            width: '100%',
        },
    }
}));

function ChargeModal({ isOpen, onClose, url }) {
    const [amount, setAmount] = useState(0);
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    
    const handleIncrement = () => {
        if (isNaN(parseInt(amount))) {
            setAmount(10000);
        } else {
            setAmount(parseInt(amount) + 10000);
        }
    };
    
    const handleDecrement = () => {
        if (isNaN(parseInt(amount))) {
            setAmount(0);
        } else if (parseInt(amount) <= 10000) {
            setAmount(0);
        } else {
            setAmount(parseInt(amount) - 10000);
        }
    };
    
    const handleCharge = () => {
        setLoading(true);
        api.post(url, { amount })
            .then(response => {
                console.log(response)
                const { payment_url } = response.data;
                if (url.includes('admin')) {
                    window.location.reload();
                } else {
                    window.location.href = payment_url;
                }
            })
            .catch(error => {
                toast.error('در ارتباط با درگاه پرداخت خطایی رخ داده است. لطفا دوباره تلاش کنید.');
                console.error('Error initiating payment:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    
    return (
        <Dialog open={isOpen} onClose={onClose} className={classes.dialog}>
            <div className="container">
                <div className="fs-2 fw-bold mx-4 mt-3 mb-2 bg-transparent">
                    افزایش اعتبار
                </div>
                <div style={{ minWidth: '300px' }}>
                    <div className="mx-4 fs-5">
                        مبلغ مورد نظر خود را وارد کنید
                    </div>
                    <div className="d-flex justify-content-between mt-4">
                        <button className="btn fs-1" onClick={handleIncrement}>+</button>
                        <div className="card bg-transparent border-1">
                            <div className="fs-1 text-center">
                                <div className="input-group">
                                    <input
                                        type="number"
                                        value={amount}
                                        min={0}
                                        onChange={(e) => setAmount(e.target.value)}
                                        className="form-control text-center no-border fs-2 border-0"
                                        style={{ width: '100%' }}
                                    />
                                    <div className="input-group-append my-auto">
                                        <span className="input-group-text fs-5 border-0 me-2">ریال</span>
                                    </div>
                                </div>
                                <div className="fs-5 text-black text-center rounded-bottom-2"
                                     style={{ backgroundColor: "springgreen" }}>{Wordify(Math.floor(amount / 10))} تومان
                                </div>
                            </div>
                        </div>
                        <button className="btn fs-1 text-gray" onClick={handleDecrement}>-</button>
                    </div>
                </div>
                <div className="px-2 my-2">
                    <button disabled={loading} className="btn btn-primary fs-2 mt-3 w-100" onClick={handleCharge}>
                        {loading ? (
                            <BeatLoader color="white" size={8} />
                        ): (
                            'پرداخت'
                        )}
                    </button>
                </div>
            </div>
        </Dialog>
    );
}

export default ChargeModal;
